module.exports = __webpack_public_path__ + "img/image19.7d715061.jpg";